// import React from "react";

// const videos = [
//   { id: "hSrHuvOazLY", title: "Woodland Resort Greenery Villa Tour" },
//   { id: "0VVP2eWwVU4", title: "Welcome to Woodland Resort | Villa Entrance" },
//   { id: "Z1oxeOzkM-w", title: "Woodland Resort Villa Night View" },
//   // ✅ Shorts videos added here
//   { id: "cGxc92HVgY4", title: "💦 Swimming Pool View at Woodland Resort | Surrounded by Nature 🌿" },
//   { id: "Vw5YdcVXFjg", title: "Woodland Resort Villa Tour | Peaceful Stay Amid Nature 🌿 | Luxury Room Tour" },
// ];

// const VideoSection = () => {
//   return (
//     <>
  



// <section
//   className="page-title"
//   style={{
//     backgroundImage: `
//       linear-gradient(
//         rgba(0, 0, 0, 0.6),
//         rgba(0, 0, 0, 0.6)
//       ),
//       url(/images/page-title.jpg)
//     `,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//   }}
// >
//   <div className="auto-container">
//     <div className="text-center">
//             <h1>Videos</h1>
//     </div>
//   </div>
// </section>






//       <section className="video-section">
//         <div className="auto-container text-center">
//           <h2 className="video-title">Experience Woodland Escape Resort</h2>
//           <p className="video-subtitle">
//             Watch the beauty of nature, luxury, and adventure unfold at our resort.
//           </p>

//           <div className="video-grid">
//             {videos.map((video, index) => (
//               <div className="video-card" key={index}>
//                 <div className="video-wrapper">
//                   <iframe
//                     className="video-frame"
//                     src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=1&loop=1&playlist=${video.id}&controls=0&rel=0&modestbranding=1&showinfo=0`}
//                     title={video.title}
//                     frameBorder="0"
//                     allow="autoplay; encrypted-media"
//                     allowFullScreen
//                   ></iframe>
//                 </div>
//                 <h5 className="video-name">{video.title}</h5>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default VideoSection;


// import React from "react";

// const videos = [
//   {
//     id: "96Ha5hXaZkM",
//     title: "Woodland Resort Nature & Greenery View",
//   },
//   {
//     id: "YNkjGypkyfc",
//     title: "Woodland Resort Villa Night View",
//   },
//   {
//     id: "f-9Hh1vvbeA",
//     title: "💦 Swimming Pool View at Woodland Resort | Surrounded by Nature",
//   },
//   {
//     id: "lb7O5qSMpTU",
//     title: "Woodland Resort Villa Tour | Peaceful Stay Amid Nature 🌿 | Luxury Room Tour",
//   },
// ];

// const VideoSection = () => {
//   return (
//     <>
   
//       <section
//         className="page-title"
//         style={{
//           backgroundImage: `
//             linear-gradient(
//               rgba(0, 0, 0, 0.6),
//               rgba(0, 0, 0, 0.6)
//             ),
//             url(/images/page-title.jpg)
//           `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="auto-container">
//           <div className="text-center">
//             <h1>Videos</h1>
//           </div>
//         </div>
//       </section>

//       {/* Video Section */}
//       <section className="video-section">
//         <div className="auto-container text-center">
//           <h2 className="video-title">Experience Woodland Escape Resort</h2>
//           <p className="video-subtitle">
//             Watch the beauty of nature, luxury, and comfort unfold at our resort.
//           </p>

//           <div className="video-grid">
//             {videos.map((video, index) => (
//               <div className="video-card" key={index}>
//                 <div className="video-wrapper">
//                   <iframe
//                     className="video-frame"
//                     src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=1&loop=1&playlist=${video.id}&controls=0&rel=0&modestbranding=1&playsinline=1`}
//                     title={video.title}
//                     frameBorder="0"
//                     allow="autoplay; encrypted-media"
//                     allowFullScreen
//                   ></iframe>
//                 </div>
//                 <h5 className="video-name">{video.title}</h5>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default VideoSection;









import React from "react";

const videos = [
  {
    id: "96Ha5hXaZkM",
    title: "Woodland Resort Nature & Greenery View",
  },
  {
    id: "YNkjGypkyfc",
    title: "Woodland Resort Villa Night View",
  },
  {
    id: "f-9Hh1vvbeA",
    title: "💦 Swimming Pool View at Woodland Resort | Surrounded by Nature",
  },
  {
    id: "lb7O5qSMpTU",
    title: "Woodland Resort Villa Tour | Peaceful Stay Amid Nature 🌿 | Luxury Room Tour",
  },
];

const VideoSection = () => {
  return (
    <>
      {/* PAGE TITLE */}
      <section
        className="page-title"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(0, 0, 0, 0.6),
              rgba(0, 0, 0, 0.6)
            ),
            url(/images/page-title.jpg)
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="auto-container">
          <div className="text-center">
            <h1>Videos</h1>
          </div>
        </div>
      </section>

      {/* VIDEO SECTION */}
      <section className="video-section">
        <div className="auto-container">
          <div className="text-center mb-5">
            <h2 className="video-title">Experience Woodland Escape Resort</h2>
            <p className="video-subtitle">
              Watch the beauty of nature, luxury, and comfort unfold at our resort.
            </p>
          </div>

          <div className="video-grid">
            {videos.map((video, index) => (
              <div className="video-card" key={index}>
                <div className="video-wrapper tall-video">
                  <iframe
                    className="video-frame"
                    src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=1&loop=1&playlist=${video.id}&controls=0&rel=0&modestbranding=1&playsinline=1`}
                    title={video.title}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  ></iframe>
                </div>
                <h5 className="video-name">{video.title}</h5>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default VideoSection;
